import React from 'react';
import clsx from 'clsx'; // Optional, helps clean up class merging

type ButtonProps = {
    label?: string;
    bgColor?: string;
    hoverColor?: string;
    className?: string;
    onClick?: () => void;
  };
  
  const RoundRectButton: React.FC<ButtonProps> = ({
    label = 'Billing Portal',
    bgColor = 'bg-orange-600',
    hoverColor = 'hover:bg-orange-400',
    className = '',
    onClick,
  }) => {
    return (
      <button
        onClick={onClick}
        type="button"
        className={clsx(
          'ml-auto text-white px-4 py-2 rounded-2xl transition-colors',
          bgColor,
          hoverColor,
          className
        )}
      >
        {label}
      </button>
    );
  };
  
  export default RoundRectButton;